function Settings() {
    return(
        <h1>yet to post</h1>
    )
}
export default Settings;